const radioOpenBtnEls = document.querySelectorAll('.js-radio-open');

if (radioOpenBtnEls) {
  [...radioOpenBtnEls].forEach((item) => {
    item.addEventListener('click', (event) => {
      const target = document.querySelector(event.currentTarget.dataset.open);
      target.classList.toggle('k-d-none');
    });
  });
}
